var _path, _path2;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgFlag = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 2.911c7.95-2.884 12.009 2 15 2 1.169-0.019 2.267-0.304 3.243-0.795l-0.043 0.020c1.024-0.451 1.8-0.193 1.8 0.866v8c-0.025 0.634-0.416 1.171-0.966 1.408l-0.010 0.004c-6.373 2.565-11.107-2.412-14.024-2.412-3.017 0-3.984 2-5 2 0-1.991 0-9.099 0-11.091z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 4.002c0.552 0 1 0.448 1 1v16c0 0.552-0.448 1-1 1s-1-0.448-1-1v-16c0-0.552 0.448-1 1-1z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFlag, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/flag.c0c2aef9.svg";
export { ForwardRef as ReactComponent };